import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

const CompanyHeader = ({ headerText }) => (
  <div>
    <div
      className={classNames([
        'company-header__cont',
        classes('width-100'),
        classes('margin-horizontal-auto'),
        classes('margin-top-5'),
        classes('margin-bottom-3'),
        classes('uppercase'),
        classes('text-small'),
        classes('bold'),
        classes('text-align-center'),
      ])}
    >
      {headerText}
    </div>
    <hr
      className={classNames([
        'company-header__border',
        classes('border-green-light'),
        classes('margin-bottom-5'),
      ])}
    />
  </div>
);

CompanyHeader.propTypes = {
  headerText: PropTypes.string,
};

CompanyHeader.displayName = 'Company Header';

export default CompanyHeader;
